<template>
  <div class="activity-library-drafts-table">
    <div v-if="isCollapseStateModifiable">
      <ActivityLibraryTable
        :data="tableData"
        :count="count"
        :title="tableType"
        @previewActivity="previewActivity($event)"
        @toggleCollapseState="toggleCollapseState"
        :isCollapsed="isCollapsed"
        :showCollapseRow="true"
        :currentView="currentView"
        :views="draftViews"
        @onSortColumn="onSortColumn"
        @deleteActivity="deleteActivity"
        :viewMode="viewMode"
        :previewSelectedId="previewSelectedId"
        @onPageChange="onPageChange"
        :pagination="pagination"
        :isPaginate="isPaginate"
        @changeStatustoArchive="changeStatustoArchive"
        :tableType="tableType"
        @onPinActivity="onPinActivity"
        @onUnpinActivity="onUnpinActivity"
        @refreshActivityList="refreshActivityList"
      ></ActivityLibraryTable>
    </div>

    <div v-else>
      <ActivityLibraryTable
        :data="tableData"
        :count="count"
        :title="tableType"
        @previewActivity="previewActivity($event)"
        :currentView="currentView"
        :views="draftViews"
        @onSortColumn="onSortColumn"
        @deleteActivity="deleteActivity"
        :viewMode="viewMode"
        :previewSelectedId="previewSelectedId"
        @onPageChange="onPageChange"
        :pagination="pagination"
        :isPaginate="isPaginate"
        @changeStatustoArchive="changeStatustoArchive"
        :tableType="tableType"
        @onPinActivity="onPinActivity"
        @onUnpinActivity="onUnpinActivity"
        @refreshActivityList="refreshActivityList"
      ></ActivityLibraryTable>
    </div>
  </div>
</template>

<script>
import ActivityLibraryTable from "@/components/activity-library/activity-library-table";
import * as columnNames from "@/constants/activity-library-and-configurator-component/column-names";
import _ from "lodash";

export default {
  name: "DraftsTable",
  components: {
    ActivityLibraryTable
  },
  data() {
    return {
      MAX_ROWS_TO_DISPLAY_IN_COLLAPSED_STATE: 3,
      isCollapsed: true
    };
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    count: {},
    currentView: {
      type: Number
    },
    views: {},
    viewMode: {
      type: Boolean,
      default: false
    },
    previewSelectedId: null,
    pagination: {},
    tableType: {}
  },
  computed: {
    tableData() {
      if (!this.isCollapseStateModifiable) {
        return this.data;
      }
      if (this.isCollapsed) {
        let slicedData = { ...this.data };
        slicedData = this.data.slice(0, this.MAX_ROWS_TO_DISPLAY_IN_COLLAPSED_STATE);
        return slicedData;
      }
      return this.data;
    },
    draftViews() {
      const draftViews = _.cloneDeep(this.views);
      draftViews["1"].push(columnNames.ACTION);
      draftViews["2"].push(columnNames.ACTION);
      draftViews["1"].unshift(columnNames.PREVIEW);
      draftViews["2"].unshift(columnNames.PREVIEW);

      // ACTIVE ACTIVITIES CHANGES

      if (this.tableType == "Drafts") {
        draftViews["1"].unshift(columnNames.EMPTY_PIN);
        draftViews["2"].unshift(columnNames.EMPTY_PIN);
      } else if (this.tableType == "Active") {
        draftViews["1"].unshift(columnNames.PIN);
        draftViews["2"].unshift(columnNames.PIN);
      }
      return draftViews;
    },
    isCollapseStateModifiable() {
      if (this.data.length <= this.MAX_ROWS_TO_DISPLAY_IN_COLLAPSED_STATE) {
        return false;
      }
      return true;
    },

    isPaginate() {
      if (this.isCollapsed) {
        return false;
      }

      return true;
    }
  },
  mounted() {
    this.activityId = this.$route.params.activityId;
    if (this.data.length > this.MAX_ROWS_TO_DISPLAY_IN_COLLAPSED_STATE) {
      this.isCollapsed = true;
    }
  },
  methods: {
    deleteActivity(activityId) {
      this.$emit("deleteActivity", activityId);
    },
    toggleCollapseState() {
      this.isCollapsed = !this.isCollapsed;
    },
    onSortColumn(eventData) {
      this.$emit("onSortColumn", eventData);
    },
    previewActivity(previewActivityObj) {
      this.$emit("previewActivity", previewActivityObj);
    },
    onPageChange(direction) {
      this.$emit("onPageChange", direction);
    },
    onPinActivity(activityId) {
      this.$emit("onPinActivity", activityId);
    },
    onUnpinActivity(activityId) {
      this.$emit("onUnpinActivity", activityId);
    },
    changeStatustoArchive(reqObj) {
      this.$emit("changeStatustoArchive", reqObj);
    },
    refreshActivityList(reqObj) {
      this.$emit("refreshActivityList", reqObj);
    }
  }
};
</script>

<style scoped lang="scss">
.activity-library-drafts-table {
  &__collapse-row {
    background-color: white;
  }
}
</style>
